import { AuctionAbstractDTO } from "../DTO/auctionAbstractDTO";
import { Address } from "./address";
import { AuctionSchedule } from "./auctionSchedule";

export class AuctionAbstract{

    public id!:number;
    public businessId!:string;
    public auctionIsLive:boolean = false;
    public auctionType?:number; //1=Regular Auction, 2=Make Offer/Buy Now, 3=For Sale, 4=Call For Offers
    public auctionStatus?:number;
    public scheduleSeqNo?:number;
    public reservePrice?:number;
    public buyerPremium?:number;
    public deposit?:number;
    public depositValue?:number;
    public propertyId!:number;
    public propertyHeader?:string;
    public propertyAddress?:Address;
    public caseNo?:string;
    public plaintiff?:string;
    public defendant?:string;
    public parcelId?:string;
    public appraisalAmount?:number;
    public imageReference?:string;
    public saleTypeId?:number;
    public propertyTypeId?:number;
    public legalAdRequired:boolean = false;
    public legalAdAllowsMultipleSales:boolean = false;
    public hasLegalAd:boolean = false;
    public legalAdConfirmed:boolean = false;
    public forceTownships:boolean = false;
    public readyForLegalAd:boolean = false;
    public readyForAuction:boolean = false;
    public legalAdNonComplianceReasons?:string;
    public auctionNonComplianceReasons?:string;

    public schedule:AuctionSchedule[]=[];

    public inLegalAdBasket:boolean=false;
    
    get canGoLive():boolean{
        return this.auctionNonComplianceReasons==undefined || this.auctionNonComplianceReasons.length==0;
    }

    constructor(){
    }

    public static mapToDTO(param:AuctionAbstract) : AuctionAbstractDTO{
        
        let dto = new AuctionAbstractDTO();
        try
        {
            dto.id = param.id;
            dto.businessId = param.businessId;
            dto.auctionIsLive = param.auctionIsLive;
            dto.auctionType = param.auctionType;
            dto.auctionStatus = param.auctionStatus;
            dto.scheduleSeqNo = param.scheduleSeqNo;
            dto.reservePrice = param.reservePrice;
            dto.buyerPremium = param.buyerPremium;
            dto.deposit = param.deposit;
            dto.depositValue = param.depositValue;
            dto.propertyId = param.propertyId;
            dto.propertyHeader = param.propertyHeader;
            dto.propertyAddress = param.propertyAddress;
            dto.caseNo = param.caseNo;
            dto.plaintiff = param.plaintiff;
            dto.defendant = param.defendant;
            dto.parcelId = param.parcelId;
            dto.appraisalAmount = param.appraisalAmount;
            dto.imageReference = param.imageReference;
            dto.saleTypeId = param.saleTypeId;
            dto.propertyTypeId = param.propertyTypeId;
            dto.legalAdRequired = param.legalAdRequired;
            dto.legalAdAllowsMultipleSales = param.legalAdAllowsMultipleSales;
            dto.hasLegalAd = param.hasLegalAd;
            dto.legalAdConfirmed = param.legalAdConfirmed;
            dto.forceTownships = param.forceTownships;
            dto.readyForLegalAd = param.readyForLegalAd;
            dto.readyForAuction = param.readyForAuction;
            dto.legalAdNonComplianceReasons = param.legalAdNonComplianceReasons;
            dto.auctionNonComplianceReasons = param.auctionNonComplianceReasons;
            if(param.schedule){
                dto.schedule = param.schedule.map(as=>AuctionSchedule.mapToDTO(as));
            }
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:AuctionAbstractDTO) : AuctionAbstract
    {
        
        let obj = new AuctionAbstract();
        try
        {
            obj.id = param.id;
            obj.businessId = param.businessId;
            obj.auctionIsLive = param.auctionIsLive;
            obj.auctionType = param.auctionType;
            obj.auctionStatus = param.auctionStatus;
            obj.scheduleSeqNo = param.scheduleSeqNo;
            obj.reservePrice = param.reservePrice;
            obj.buyerPremium = param.buyerPremium;
            obj.deposit = param.deposit;
            obj.depositValue = param.depositValue;
            obj.propertyId = param.propertyId;
            obj.propertyHeader = param.propertyHeader;
            obj.propertyAddress = param.propertyAddress;
            obj.caseNo = param.caseNo;
            obj.plaintiff = param.plaintiff;
            obj.defendant = param.defendant;
            obj.parcelId = param.parcelId;
            obj.appraisalAmount = param.appraisalAmount;
            obj.imageReference = param.imageReference?param.imageReference:"assets/images/others/no_image.jpg";
            obj.saleTypeId = param.saleTypeId;
            obj.propertyTypeId = param.propertyTypeId;
            obj.legalAdRequired = param.legalAdRequired;
            obj.legalAdAllowsMultipleSales = param.legalAdAllowsMultipleSales;
            obj.hasLegalAd = param.hasLegalAd;
            obj.legalAdConfirmed = param.legalAdConfirmed;
            obj.forceTownships = param.forceTownships;
            obj.readyForLegalAd = param.readyForLegalAd;
            obj.readyForAuction = param.readyForAuction;
            obj.legalAdNonComplianceReasons = param.legalAdNonComplianceReasons;
            obj.auctionNonComplianceReasons = param.auctionNonComplianceReasons;
            if(param.schedule){
                obj.schedule = param.schedule.map(as=>AuctionSchedule.mapFromDTO(as));
            }
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}